import { connect } from 'react-redux';
import LoadTruckFormComponent from './LoadTruckFormComponent';
import { loadTruck } from '../../store/actions/truck';

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  submit: loadTruck.request,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoadTruckFormComponent);
